/** Build /itinerary-planner deep link with query params for prefilled form. */
export function buildPlannerHref({ city, days, matchDay, budget, transport, premium } = {}) {
  const q = new URLSearchParams();
  if (city) q.set('city', city);
  if (days != null) q.set('days', String(days));
  if (matchDay != null && matchDay !== '') q.set('matchDay', String(matchDay));
  if (budget) q.set('budget', budget);
  if (transport) q.set('transport', transport);
  if (premium) q.set('premium', '1');
  const s = q.toString();
  return s ? `/itinerary-planner?${s}` : '/itinerary-planner';
}
